import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import pt from 'vuetify/lib/locale/pt' // Caminho correto para Vue 2 + Vuetify 2
// import 'vuetify/src/stylus/app.styl' // Remover - não é mais necessário

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'md'
  },
  lang: {
    locales: { pt },
    current: 'pt'
  },
  theme: {
    themes: {
      light: {
        primary: '#ffc107',
        secondary: '#783534',
        tertiary: '#495057',
        accent: '#ffa014',
        error: '#FF5252',
        info: '#26E3DB',
        success: '#8CE326',
        warning: '#FFC107'
      }
    }
  }
})
